export const HISTOGRAM_CELL_RENDERER = 'histogramCellRenderer';
